import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelCF = props => {
    return (
      <option value={props.elemento.cicloFact}>{props.elemento.cicloFact}</option>
    )
  };
  
  const ListaCF = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
    const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelCF styles={styles} elemento={elemento} key={elemento._id} />);
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" value={(permiteUpdate||!idLista.cicloFact)?argsDocum.cicloFact:idLista.cicloFact} onChange={(ev)=>handleChange(ev, argsDocum)}>
          {NivelDetalleES}
        </select>
      </div>
    )
  };

class VerTar2 extends React.Component {
    state={
        argsDocum: {
            codigoTarifa: this.props.idLista.codigoTarifa,
            descrTarifa: this.props.idLista.descrTarifa,
            estadoTarifa: this.props.idLista.estadoTarifa,
            cicloFactAnt: this.props.idLista.cicloFact?this.props.idLista.cicloFact:this.props.list8[0].cicloFact,
            cicloFact: this.props.idLista.cicloFact?this.props.idLista.cicloFact:this.props.list8[0].cicloFact,
            _id: this.props.idLista._id
        },
        confirmaAct: false,
        open: false
    }

    handleChange = (ev) => {
      if (this.props.permiteUpdate){
        this.setState({confirmaAct: false})
        const argsDocum = this.state.argsDocum
        if(ev.target.name !== "codigoTarifa"){
          if(ev.target.name === "estadoTarifa"){
            if(argsDocum.estadoTarifa === true){
              argsDocum[ev.target.name] = false
            }else{
              argsDocum[ev.target.name] = true
            }
          }else{
            if(ev.target.name === "cicloFact"){
              // Se modifica el ciclo de la tarifa solo si tiene la autorizacion
              if(this.props.a25100505!==-1){
                // var miLista = document.getElementById("miListaCF");
                // argsDocum['cicloFact'] = miLista.options[miLista.selectedIndex].text
                // console.log(ev.target.name, ev.target.value, miLista.options[miLista.selectedIndex].text)
                argsDocum[ev.target.name] = ev.target.value
              }
            }else{
              argsDocum[ev.target.name] = ev.target.value
            }
          }
          this.setState({argsDocum});        
        }
      }
    }

    handleQuestionUpdDel = async (ev) => {
        var btnPress = await ev.target.attributes[0].value
        if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
        if(btnPress==="No"){
            this.setState({open: false})
        };
        if(btnPress==="Si"){
            this.setState({confirmaAct: true})
            this.setState({open: false})
            const myBtn = await document.getElementById("btnUpdDel");
            myBtn.click()
        }
    }

    render(){
        const {argsDocum, confirmaAct, open} = this.state;
        // console.log(argsDocum.comoAsigCicloFact)
        // console.log(this.props.comoAsigCicloFact)
        return(
            <div>
                <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                    <i className="large hand point down yellow icon"></i>
                    Tarifa
                </button>
                <div style={this.props.styles.box}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum, this.props.idLista.descrTarifa):()=>{}}>
                        <div className="ui one column stackable grid">
                            <div className="row container">
                                <div className="column" width="100%">
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Código</label>
                                        <Form.Input autoComplete="off" name="codigoTarifa" id="codigoTarifa" value={argsDocum.codigoTarifa} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoTarifa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Descripción</label>
                                        <Form.Input autoComplete="off" name="descrTarifa" id="descrTarifa" value={this.props.permiteUpdate?argsDocum.descrTarifa:this.props.idLista.descrTarifa} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrTarifa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    {this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa" &&
                                    <Form.Field>
                                      <label style={this.props.styles.label}>Ciclo de facturación</label>
                                      <ListaCF list={this.props.list8} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </Form.Field>
                                    }

                                    <Form.Field>
                                        <label style={this.props.styles.label}>Inactiva / Activa</label>
                                        <Form.Checkbox name="estadoTarifa" id="estadoTarifa" className='ui fitted toggle checkbox' checked={argsDocum.estadoTarifa} onChange={this.handleChange}/>
                                    </Form.Field>


                                    {/* <Form.Field>
                                        <label style={this.props.styles.label}>% Impuesto</label>
                                        <Form.Input autoComplete="off" name="porcTarifa" id="porcTarifa" type="number" step="0.01" value={argsDocum.porcTarifa} onChange={this.handleChange} placeholder='% Impuesto' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'porcTarifa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field> */}

                                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>

                                {
                                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }

                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default VerTar2
